import type { MyProfile } from '@onestep/camel-api';

export const getMissingProfileFields = (profile?: MyProfile): Array<'firstName' | 'lastName'> => {
  if (!profile) return ['firstName', 'lastName'];

  const missing: Array<'firstName' | 'lastName'> = [];

  if (!profile.firstName?.trim()) missing.push('firstName');
  if (!profile.lastName?.trim()) missing.push('lastName');

  return missing;
};
